export const EDIT_SKILL = "EDIT_SKILL"
export const EDIT_SKILL_SUCCESS = "EDIT_SKILL_SUCCESS"
export const EDIT_SKILL_CLEAN = "EDIT_USER_CLEAN"
export const EDIT_SKILL_ERROR = "EDIT_SKILL_ERROR"
